// extracted by mini-css-extract-plugin
export default {"item":"BLORCD28zM2ixt19WpPN"};